import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Production
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// Local Testing
// import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
// import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const app = initializeApp(JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG!));

const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const analytics =
  process.env.NODE_ENV === "development" ? undefined : getAnalytics(app);

// Locatl testing
// connectFunctionsEmulator(functions, "localhost", 5001);
// connectFirestoreEmulator(db, "localhost", 8080);

export { db, functions, auth, analytics };
